"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const HBButton_1 = require("@components/library/HBButton");
const FormButton = (props, ref) => {
    const { disabled, fullWidth = true, variant = 'contained', color = 'primary', ...other } = props;
    return React.createElement(HBButton_1.default, Object.assign({ ref: ref, variant: variant, color: color, fullWidth: fullWidth, disabled: disabled }, other));
};
exports.default = React.forwardRef(FormButton);
